import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCJwU3HCh4qbE55Vh9uwxG-SfFTG24T81M",
  authDomain: "myslackclone-ea8ca.firebaseapp.com",
  projectId: "myslackclone-ea8ca",
  storageBucket: "myslackclone-ea8ca.appspot.com",
  messagingSenderId: "358345731828",
  appId: "1:358345731828:web:3cb41f9330850fa518b8a1",
  measurementId: "G-PHSWZQCWR9",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
